export enum TableRowType {
  HEADER_CELL = "header_cell",
  NORMAL_CELL = "normal_cell",
  VACANT_CELL = "vacant_cell",
}
